// @ts-nocheck
import { useGet as Get, usePost as Post, usePut as Put, useDelete as Delete } from "./useRequest";

export const loadDocumentCategoriesByOrg = (organisationId) => {
  const path = `/documentcategory/${organisationId}/all`;
  const response = Get(path);
  return response;
};

export const getDocumentCategory = (categoryId) => {
    const path = `/documentcategory/${categoryId}`;
    const response = Get(path);
    return response;
};

export const createDocumentCategory = (documentCategory) => {
    const path = `/documentcategory`;
    const data = documentCategory;
    if (!path) {
        throw new Error("Path is required");
    }
    const response = Post(path, data);
    return response;
  };

  export const updateDocumentCategory = (docCategoryId, documentCategory) => {
    const path = `/documentcategory/${docCategoryId}/update`;
    if (!path) {
        throw new Error("Path is required");
    }
    const response = Put(path, documentCategory);
    return response;
  };

  export const deleteDocumentCategory = (docCategoryId) => {
    const path = `/documentcategory/${docCategoryId}/delete`;

    if (!path) {
      throw new Error("Path is required");
    }
    const response = Delete(path);
    return response;
  };